__turbopack_context__.v({
  "arrowButton": "Header-module__7xG_1q__arrowButton",
  "bgPicture": "Header-module__7xG_1q__bgPicture",
  "bunnlinje": "Header-module__7xG_1q__bunnlinje",
  "fadeIn": "Header-module__7xG_1q__fadeIn",
  "header": "Header-module__7xG_1q__header",
  "left": "Header-module__7xG_1q__left",
  "overlay": "Header-module__7xG_1q__overlay",
  "panel": "Header-module__7xG_1q__panel",
  "right": "Header-module__7xG_1q__right",
  "topplinje": "Header-module__7xG_1q__topplinje",
  "video": "Header-module__7xG_1q__video",
});
